// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1u7Zc","footer":"ModalUpdate_footer__YNcMr"};